import React from 'react';
import CommProcess from './CommProcess'

export default class VAProcess extends CommProcess {

  filtered = {
    // 选择的EM序号
    filterResults: undefined,
    // 指定EM是否被选择
    filterMap: undefined,
    filterTeamMap: undefined,
    // 按降序统计各分类法对选择结果的分类结果
    filterOrganisms: undefined,
    filterTeams: undefined,
    filterPublications: undefined,
    // 各分类法前十的对比数据，按重建方法二次区分
    compareOrganisms: undefined,
    compareTeams: undefined,
    comparePublications: undefined,
    compareDataInfo: undefined,
    // 关系子集
    filterTeamLinks: undefined,
    // 最新信息
    lastestEMDIndex: 0,
  };

  updateFilterResults(filterResults) {
    let {
      listEMMethod,
      listOrganism,
      listTeam,
      listPublication,
      linksTeam,
      dataListEMDs,
    } = this.base;
    //filterResults.splice(1970, 10000);
    this.filtered.filterResults = filterResults;
    this.filtered.filterOrganisms =
      listOrganism.map((o, index) => ({name: o.name, id: index, ncbi: o.id, value: 0}));
    this.filtered.filterTeams =
      listTeam.map((t, index) => ({id: index, value: 0, ...t}));
    this.filtered.filterPublications =
      listPublication.map((p, index) => ({name: p.name, id: index, value: 0}));
    this.filtered.filterMap = dataListEMDs.map(d => false);
    this.filtered.filterResults.forEach(i => {
      dataListEMDs[i].o.map(o => {
        if(this.filtered.filterOrganisms[o])
          this.filtered.filterOrganisms[o].value++;
      })
      dataListEMDs[i].u.map(u => {
        if(this.filtered.filterTeams[u])
          this.filtered.filterTeams[u].value++;
      })
      if(this.filtered.filterPublications[dataListEMDs[i].p])
        this.filtered.filterPublications[dataListEMDs[i].p].value++;
      this.filtered.filterMap[i] = true;
    });
    this.filtered.filterOrganisms = this.filtered.filterOrganisms.filter(c => c.value>0);
    this.filtered.filterOrganisms.sort((a,b) => b.value-a.value);
    this.filtered.filterTeams = this.filtered.filterTeams.filter(c => c.value>0);
    this.filtered.filterTeams.sort((a,b) => b.value-a.value);
    this.filtered.filterPublications = this.filtered.filterPublications.filter(c => c.value>0);
    this.filtered.filterPublications.sort((a,b) => b.value-a.value);

    this.filtered.filterTeamMap = listTeam.map(d => false);
    this.filtered.filterTeams.forEach(t => {
      this.filtered.filterTeamMap[t.id] = true;
    });

    this.filtered.compareOrganisms = this.filtered.filterOrganisms.map(c => {
      let counterMethod = listEMMethod.map(m => 0);
      filterResults.forEach(i => {
        if(dataListEMDs[i].o.indexOf(c.id) >= 0)
          counterMethod[dataListEMDs[i].m]++;
      });
      return {
        name: c.name,
        id: +c.id,
        values: counterMethod,
      };
    })
    this.filtered.compareTeams = this.filtered.filterTeams.map(c => {
      let counterMethod = listEMMethod.map(m => 0);
      filterResults.forEach(i => {
        if(dataListEMDs[i].u.indexOf(c.id) >= 0)
          counterMethod[dataListEMDs[i].m]++;
      });
      return {
        name: c.name,
        id: +c.id,
        values: counterMethod,
      };
    })
    this.filtered.comparePublications = this.filtered.filterPublications.map(c => {
      let counterMethod = listEMMethod.map(m => 0);
      filterResults.forEach(i => {
        if(dataListEMDs[i].p === c.id)
          counterMethod[dataListEMDs[i].m]++;
      });
      return {
        name: c.name,
        id: +c.id,
        values: counterMethod,
      };
    })
    this.filtered.compareDataInfo = listEMMethod.map((m, index) => ({name: `${m.name}`, id: index}))

    this.filtered.filterTeamLinks = linksTeam.filter(l => this.filtered.filterTeamMap[l.source] && this.filtered.filterTeamMap[l.target])

    this.filtered.lastestEMDIndex = filterResults.reduce((a,b) => dataListEMDs[a].t > dataListEMDs[b].t ? a : b, 0)

    this.updateVAInfo();
  }

}
